export default "__VITE_ASSET__CNBQ4JK7__"